<template>
  <div id="app">
    <router-view ref="refChildCommunity"/>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import { mapState, mapGetters } from 'vuex';
import { updateTheme, empty, clearCacheData } from 'ant-design-vue-admin-x';
import noticeLogo from './assets/images/ehm.png';

export default {
  mixins: [clearCacheData],
  computed: {
    ...mapState(['defaultTheme', 'permissions']),
    ...mapGetters(['roles'])
  },
  watch: {
    roles: {
      deep: true,
      handler (val) {
        val && this.getAskPermission();
      }
    }
  },
  data () {
    return {};
  },
  created () {
    empty.$on('setCacheData', () => {
      this.clearData();
    });

    const color = Cookies.get('themeColor');
    if (color && color !== '#1890FF') {
      this.$store.commit('TOGGLE_COLOR', color);
      updateTheme(color);
    }
  },
  methods: {
    /** 判断是否有社区咨询消息提醒的权限 */
    getAskPermission () {
      const hasAsk = this.permissions && this.permissions.some(item => item === 'goverment:communityAsk:list');
      console.log('社区咨询权限 hasAsk: ', hasAsk);
      if (hasAsk) { // 首次进页面即查询一次 每隔一分钟向后台查询一次消息提醒
        this.getAskMessage().then(() => {
          this.setIntervalMessage();
        });
      }
    },
    // 获取消息提醒
    getAskMessage () {
      return this.$get({
        url: '/counselling/messages'
      }).then(({data}) => {
        let { reminder, msg } = data;
        if (!reminder) return;
        this.openNotification(msg);
      });
    },
    // 消息提醒弹出框
    openNotification (msg) {
      this.$notification.destroy();
      this.$notification.open({
        message: '浩邈社区提醒您:',
        duration: null,
        description: msg,
        icon: h => h('img', {
          attrs: { src: noticeLogo },
          style: { width: '50px', marginLeft: '-10px' }
        }),
        placement: 'bottomRight',
        key: 'message',
        onClick: () => {
          this.$notification.destroy();
          if (this.$route.name === 'communityAsk') {
            this.$refs.refChildCommunity.$refs.table.getTableList();
          } else {
            this.$router.push('/communityAsk');
          }
        }
      });
    },
    // 延时调用获取消息
    setIntervalMessage () {
      setTimeout(() => {
        this.getAskMessage().then(() => {
          this.setIntervalMessage();
        });
      }, 60 * 1000);
    }
  }
};
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
